<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->

<template>
  <div id="page-role-view view-page">
    <vs-alert color="danger" title="Role Not Found" :active.sync="not_found">
      <span>Role record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'role.list'}" class="text-inherit underline">All
        Roles</router-link>
      </span>
    </vs-alert>

    <div v-if="data">
      <vs-row >
        <vs-col>
          <vs-row>
            <vs-col>
              <h2 class="mb-4">{{ data.RoleName }}</h2>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>
              <div class="vx-card p-4">
                <role-view-details :data="data" />
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button
                v-if="data.IsDeleted == 0 && componentAccess.canDelete.access"
                @click="deleteRole"
              class="my-4"
            >Delete</vs-button>
          </div>
        </div>
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button
                v-if="data.IsDeleted == 0 && componentAccess.canEdit.access"
                color="light"
                @click="edit" class="my-4"
            >Edit</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>



import RoleViewDetails from "@/views/pages/role/view/RoleViewDetails";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

export default {
  components: {
    RoleViewDetails,
  },
  mixins: [CanAccessMixin],
  data () {
    return {
      data: null,
      not_found: false,
      componentAccess: {
        canEdit: {
          route: 'role.edit',
          access: false,
        },
        canDelete: {
          route: 'role.delete',
          access: false,
        },
      }
    }
  },
  computed: {
    id() {
      return this.data.id;
    }
  },
  methods: {
    async fetch(roleId) {
      try {
        const { data } = await this.$api.roles.get(roleId, { params: {'include' : 'applications'} });
        this.data = data.data;
      } catch (e) {
        console.error(e)
      } finally {
        if (!this.data) {
          this.not_found = true
        }
      }
    },
    edit() {
      this.$router.push({ name: 'role.edit', params: { id: this.data.id }}).catch(() => {})
    },
    deleteRole() {
      const deleteRecord = async () => {
        try {
          await this.$api.roles.delete(this.id);
          await this.$router.push({ name: 'role.list' }).catch(() => {})
        } catch(e) {
          console.log(e);
        }
      }

      const message = "Warning: this operation is not reversible. Please confirm deletion of this role. "
              + "If a record is deleted in error please contact Furness IT Support. "
              + "Are you sure you want to delete this role?";

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: message,
        accept: deleteRecord,
        acceptText: 'Delete'
      })
    }
  },
  created () {
    this.fetch(this.$route.params.id)
  }
}

</script>
<style lang="scss">
.view-page {
  .vs-input--label {
    padding-left: 0;
  }
}
</style>
